export class PerfilTareaDataModel {
    perfilId: number;
    tareaId: number;
    puedeLeer: boolean;
    puedeCrear: boolean;
    puedeEscribir: boolean;
    puedeBorrar: boolean;
    puedeAprobar: boolean;
    puedeImportarArchivo: boolean;
    puedeAsignarResponsable: boolean;
    puedeCargarIncidencia: boolean;
}